function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { BLUE_600, GREEN_400, GREEN_600, GREY_50, GREY_100, GREY_200, GREY_300, GREY_400, GREY_500, GREY_600, GREY_700, GREY_800, GREY_850, GREY_900, ILLUSTRATION_BLACK, ILLUSTRATION_BLUE, ILLUSTRATION_GREEN, ILLUSTRATION_YELLOW, KAGGLE_BLACK, KAGGLE_BLUE, KAGGLE_GREEN, KAGGLE_PURPLE, KAGGLE_ORANGE, KAGGLE_YELLOW, KAGGLE_WHITE, RED_50, RED_400, RED_600, YELLOW_400, YELLOW_900 } from "./colorConstants";
/**
 * Pairs of light and dark colors based on a role. See color roles for more
 * details: http://shortn/_eY8GHamsXM
 */ var roleColors = {
    light: {
        background: {
            normal: KAGGLE_WHITE,
            menu: KAGGLE_WHITE,
            active: KAGGLE_WHITE,
            code: GREY_100
        },
        outline: {
            normal: GREY_300,
            medium: GREY_400,
            high: GREY_900,
            divider: GREY_300
        },
        status: {
            valid: GREEN_600,
            caution: YELLOW_900,
            error: RED_600,
            info: GREY_700
        },
        text: {
            high: GREY_900,
            medium: GREY_800,
            low: GREY_700,
            disabled: GREY_600,
            anchor: GREY_500,
            active: GREY_900
        }
    },
    dark: {
        background: {
            normal: GREY_900,
            menu: GREY_850,
            active: GREY_50,
            code: GREY_850
        },
        outline: {
            normal: GREY_600,
            medium: GREY_400,
            high: GREY_50,
            divider: GREY_800
        },
        status: {
            valid: GREEN_400,
            caution: YELLOW_400,
            error: RED_400,
            info: GREY_600
        },
        text: {
            high: GREY_200,
            medium: GREY_500,
            low: GREY_600,
            disabled: GREY_700,
            anchor: GREY_500,
            active: GREY_50
        }
    }
};
/**
 * KM Color palette, see Figma Stickersheets (http://shortn/_ZxUMnxgMJq) and
 * Carbon: https://carbon.googleplex.com/kaggle/pages/color
 */ var palette = {
    grey: {
        900: GREY_900,
        850: GREY_850,
        800: GREY_800,
        700: GREY_700,
        600: GREY_600,
        500: GREY_500,
        400: GREY_400,
        300: GREY_300,
        200: GREY_200,
        100: GREY_100,
        50: GREY_50
    },
    blue: {
        600: BLUE_600
    },
    green: {
        600: GREEN_600,
        400: GREEN_400
    },
    red: {
        600: RED_600,
        400: RED_400,
        50: RED_50
    },
    yellow: {
        900: YELLOW_900,
        400: YELLOW_400
    },
    // Brand colors. "Kaggle Blue", etc.
    kaggle: {
        black: KAGGLE_BLACK,
        blue: KAGGLE_BLUE,
        green: KAGGLE_GREEN,
        purple: KAGGLE_PURPLE,
        orange: KAGGLE_ORANGE,
        yellow: KAGGLE_YELLOW,
        white: KAGGLE_WHITE
    },
    // Colors used in designer illustrations; see carbon linked above.
    illustration: {
        black: ILLUSTRATION_BLACK,
        blue: ILLUSTRATION_BLUE,
        green: ILLUSTRATION_GREEN,
        yellow: ILLUSTRATION_YELLOW
    },
    /**
   * @deprecated Legacy colors without KM equivalents; these should never be
   * introduced in new code. Most colors will be migrated to KM equivalents,
   * but some edge cases require UX design team to evaluate use cases and
   * evolve the design system. For now, we port this small subset.
   */ legacy: {
        status: {
            errorBackground: RED_400,
            validBackground: GREEN_400
        }
    }
};
export function getColor(themeName) {
    return _objectSpread({}, roleColors[themeName], palette);
}
